<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <span class="mr-2" id="showEntries">{{ showEntries }}</span>
        </div>

        <form target="_blank" method="post" :action="base_app_url +'/api/admin/users/support'">
          <input type="hidden" name="type" value="csv">
          <input type="hidden" name="token" :value="csrfToken">
          <vs-button button="submit" type="border" icon="get_app">CSV</vs-button>
        </form>

        <router-link
          :to="{name:'admin-user-support-add'}"
          @click.stop.prevent
          class="text-inherit hover:text-primary ml-5"
        >
          <vs-button button="submit" type="border" icon="add">Add</vs-button>
        </router-link>
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        class="ag-theme-material w-100 my-4 ag-grid-table"
        id="myGrid"
        :gridOptions="gridOptions"
        @grid-ready="onGridReady"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :components="components"
        :animateRows="true"
        :floatingFilter="true"
        :rowSelection="rowSelection"
        :rowDeselection="true"
        :rowModelType="rowModelType"
        :cacheOverflowSize="cacheOverflowSize"
        :maxConcurrentDatasourceRequests="maxConcurrentDatasourceRequests"
        :infiniteInitialRowCount="infiniteInitialRowCount"
        :maxBlocksInCache="maxBlocksInCache"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :cacheBlockSize="cacheBlockSize"
        :getRowNodeId="getRowNodeId"
        domLayout= "autoHeight">
      </ag-grid-vue>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import axios from '@/axios.js'

// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'
import CellRendererUpdated from './cell-renderer/CellRendererUpdated.vue'

export default {
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
    CellRendererUpdated
  },
  data () {
    return {
      base_app_url : process.env.VUE_APP_API_URL,
      searchQuery: '',
      showEntries: '',
      csrfToken: '',

      // AgGrid
      gridOptions: null,
      gridApi: null,
      columnApi: null,
      columnDefs: null,
      defaultColDef: null,
      rowSelection: null,
      rowModelType: null,
      cacheOverflowSize: null,
      maxConcurrentDatasourceRequests: null,
      infiniteInitialRowCount: null,
      maxBlocksInCache: null,
      paginationPageSize: null,
      cacheBlockSize: null,
      getRowNodeId: null,
      components: null
    }
  },
  methods: {
    onGridReady (params) {
      const that = this
      const dataSource = {
        getRows (params) {
          const page_no =  params.endRow / 20
          axios
            .post(`/api/admin/users/support?page=${page_no}`,
              {
                filter: params.filterModel,
                sort: params.sortModel
              })
            .then(response => {
              that.showEntries = ''
              if (response.data.meta.from) {
                that.showEntries = `${response.data.meta.from} - ${response.data.meta.to} of ${response.data.meta.total}`
              }
              params.successCallback(response.data.data, response.data.meta.total)
            })
            .catch(error => {
              console.log(error)
            })
        }
      }
      params.api.setDatasource(dataSource)
    }
  },
  beforeMount () {
    this.gridOptions = {}
    this.columnDefs = [
      /*{
        headerName: "ID",
        field: "id",
        width: 125,
        filter: true
      },*/
      {
        headerName: 'Name',
        field: 'name',
        width: 300,
        cellRendererFramework: 'CellRendererLink',
        filter: true
      },
      {
        headerName: 'Email',
        field: 'email',
        width: 300,
        filter: true
      },
      {
        headerName: 'Verified',
        field: 'is_verified',
        width: 300,
        cellRendererFramework: 'CellRendererVerified'
      },
      {
        headerName: 'Created At',
        field: 'created_at',
        width: 300,
        cellRendererFramework: 'CellRendererUpdated',
        cellClass: 'text-center'
      }
      /*{
        headerName: "Actions",
        width: 150,
        cellRendererFramework: "CellRendererActions"
      }*/
    ]
    this.defaultColDef = {
      flex: 1,
      resizable: true,
      minWidth: 100,
      sortable: true,
      suppressMenu: true
    }
    this.rowSelection = 'multiple'
    this.rowModelType = 'infinite'
    this.cacheOverflowSize = 2
    this.maxConcurrentDatasourceRequests = 2
    this.infiniteInitialRowCount = 1
    this.maxBlocksInCache = 2
    this.paginationPageSize = 20
    this.cacheBlockSize = 20
    this.getRowNodeId = item => {
      return item.id
    }
    // Cell Renderer Components
    this.components = {
      CellRendererLink,
      CellRendererStatus,
      CellRendererVerified,
      CellRendererActions
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    this.gridColumnApi = this.gridOptions.columnApi
    /* =================================================================
              NOTE:
              Header is not aligned properly in RTL version of agGrid table.
              However, we given fix to this issue. If you want more robust solution please contact them at gitHub
            ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        '.ag-header-container'
      )
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`
    }
  },
  created () {
    this.$emit('changeRouteTitle', 'Users - Support Staff')
    this.csrfToken = localStorage.getItem('accessToken')
  }
}
</script>

<style lang="scss">
  #page-user-list {
    .user-list-filters {
      .vs__actions {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-58%);
      }
    }
  }
</style>
